// extracted by mini-css-extract-plugin
export var player = "sv9-n";
export var root = "Ni+n3";